module.exports = __webpack_public_path__ + "img/sizeicon.f9456980.png";